import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import DiariosExpo23 from '../../../components/diario/listar/expomacuco';


function DiariosExpo23Screen() {
    return (
        <Fragment>
            <Head titulo="Publicações da Expo Macuco 2023" />
            <Header />
            <Container>
                <DiariosExpo23 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DiariosExpo23Screen;